"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const ui_1 = require("react-science/ui");
const menuStyles = (0, react_1.css) `
  .menu {
    box-shadow: 0 0 10px rgb(0 0 0 / 50%);
    margin: 0;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 99999;
    padding: 2px;
    background-color: white;

    button:hover {
      background-color: #fafafa;
    }
  }

  .menu-cover {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .menu-item {
    background-color: transparent;
    border: none;
    border-bottom: 0.55px solid whitesmoke;
    height: 35px;
    outline: outline;
    display: table-cell;
    vertical-align: middle;
    text-align: left;
    padding: 0 10px;

    svg {
      display: inline-block;
    }

    :focus {
      outline: none !important;
    }

    span {
      font-size: 10px;
      padding: 0 10px;
    }
  }
`;
function MenuItem({ icon, label, onClick }) {
    return ((0, jsx_runtime_1.jsxs)("button", { type: "button", className: "menu-item", onClick: onClick, children: [icon, (0, jsx_runtime_1.jsx)("span", { children: label })] }));
}
function MenuList({ items, boxBounding, onClick }) {
    const listRef = (0, react_2.useRef)();
    const [translate, setTranslate] = (0, react_2.useState)({
        x: boxBounding.width,
        y: boxBounding.height,
    });
    (0, react_2.useLayoutEffect)(() => {
        const boxSize = listRef.current.getBoundingClientRect();
        setTranslate((oldTransform) => {
            let y = boxBounding.height;
            if (boxSize.bottom > window.innerHeight) {
                y = boxBounding.height * 2 + (boxSize.bottom - window.innerHeight);
            }
            return {
                ...oldTransform,
                y,
            };
        });
    }, [boxBounding.height]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: listRef, className: "menu", style: {
            transform: `translate(${translate.x}px, -${translate.y}px) `,
        }, children: items?.map((item) => {
            return ((0, jsx_runtime_1.jsx)(MenuItem, { ...item, onClick: () => onClick(item) }, item.id));
        }) }));
}
function ToolbarMenu({ component, toolTip = '', items = [], onClick = () => null, }) {
    const menuButtonRef = (0, react_2.useRef)(null);
    const [isShown, showMenu] = (0, react_2.useState)(false);
    const closeMenuButton = (0, react_2.useCallback)(() => {
        showMenu(false);
    }, []);
    const handleClick = (0, react_2.useCallback)(() => {
        showMenu((flag) => !flag);
    }, []);
    const clickHandler = (0, react_2.useCallback)((e) => {
        showMenu(false);
        onClick(e);
    }, [onClick]);
    const boxBounding = (0, react_2.useCallback)(() => {
        return menuButtonRef.current?.getBoundingClientRect();
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { style: { height: 'auto' }, css: menuStyles, children: [(0, jsx_runtime_1.jsx)("div", { ref: menuButtonRef, children: (0, jsx_runtime_1.jsx)(ui_1.Toolbar.Item, { id: `menu-${toolTip}`, title: toolTip, active: isShown, onClick: handleClick, children: component }) }), isShown && ((0, jsx_runtime_1.jsx)(MenuList, { items: items, boxBounding: boxBounding(), onClick: clickHandler })), isShown && (0, jsx_runtime_1.jsx)("div", { className: "menu-cover", onClick: closeMenuButton })] }));
}
exports.default = ToolbarMenu;
